import { render } from "./agenda.vue?vue&type=template&id=53cc5a7e&scoped=true"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"

import "./agenda.vue?vue&type=style&index=0&id=53cc5a7e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53cc5a7e"

export default script